import React from 'react';
import { SessionData } from '../utils/SessionTracker';
import { formatTime } from '../utils/formatTime';
import { cn } from '../utils/cn';

interface SessionUIProps {
  sessionData: SessionData;
  onEndSession: () => void;
  dropFlash: boolean;
  pipelineStats?: {
    leftPct: number;
    rightPct: number;
    meanPeakHeight: number;
    totalThrows: number;
    totalCatches: number;
  } | null;
}

export const SessionUI = ({ sessionData, onEndSession, dropFlash, pipelineStats }: SessionUIProps) => (
  <div
    className={cn(
      'p-5 text-center transition-colors duration-300',
      dropFlash ? 'bg-red-100' : 'bg-white'
    )}
  >
    <div className="text-7xl font-bold mb-5">
      {sessionData.consecutiveThrows}
    </div>
    <div className="text-4xl mb-5">
      {formatTime(sessionData.cumulativeTime)}
    </div>
    {pipelineStats != null && (
      <div className="text-sm text-gray-600 mb-3 flex justify-center gap-6">
        <span>L {pipelineStats.leftPct.toFixed(0)}%</span>
        <span>R {pipelineStats.rightPct.toFixed(0)}%</span>
        <span>Catches: {pipelineStats.totalCatches}</span>
      </div>
    )}
    <div className="text-lg text-gray-600 mb-5">
      {sessionData.throwsGoal != null && <div>Goal: {sessionData.throwsGoal} throws</div>}
      {sessionData.timeGoal != null && <div>Goal: {formatTime(sessionData.timeGoal)}</div>}
    </div>
    <button
      type="button"
      onClick={onEndSession}
      className="px-6 py-3 text-lg cursor-pointer bg-red-600 text-white border-0 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
    >
      End Session
    </button>
  </div>
);
